<template>
      <div class="accountClosingEdit">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'accountClosing', params: {} }">
          Account Closing
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'accountClosingEdit', params:{id: id} }">
            Edit Account Closing
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Edit Account Closing</v-card-title>
          <v-card-text>
            <accountClosing-form :id="id"></accountClosing-form>
          </v-card-text>
        </v-card>
      </div>
    </template>

    <script>
    import AccountClosingForm from './AccountClosingForm.vue';

    export default {
      name: 'accountClosing',
      data () {
        return {
          id: null
        }
      },
      components: {
        AccountClosingForm
      },
      created () {
          this.id = this.$route.params.id;
          this.$emit("showParent", false);
      }
    }
    </script>
    